import { Injectable } from '@angular/core';

import { User } from '../../../models/user.model';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage';

@Injectable()
export class FirebaseDbProvider {

  constructor(private _afDB: AngularFireDatabase, private _afSG: AngularFireStorage) {}

  /* STORAGE */

  async retrieveImg(valid: string, topic: string, classif: string, name: string) {
    const ref = await this._afSG.storage.ref('/' + valid + '/' + topic + '/' + classif + '/' + name + '.png');
    const observable = ref.getDownloadURL();
    let downloadURL: string;
    await observable.then(url => {
      downloadURL = url;
    });
    return downloadURL;
  }

  async uploadImg(valid: string, topic: string, classif: string, img: string, name: string) {
    const ref = await this._afSG.storage.ref('/' + valid + '/' + topic + '/' + classif + '/' + name + '.png');
    await ref.putString(img, 'data_url');
  }

  /* DATABASE */

  async saveUser(user: User, key: string) {
    await this._afDB.database.ref('/users/' + key).set(user);
  }

  async retrieveUserData(key: string) {
    let stats;
    await this._afDB.database.ref('/users/').child(key).once('value')
      .then(function(snapshot) {
        stats = snapshot.val();
      });
    return stats;
  }

  async removeUser(key: string) {
    await this._afDB.database.ref('/users/').child(key).remove();
  }

  /* STATS */

  async updateErr_Hira(res: number, key: string) {
    await this._afDB.database.ref('/users/' + key).update({ err_hira: res });
  }

  async updateErr_Kata(res: number, key: string) {
    await this._afDB.database.ref('/users/' + key).update({ err_kata: res });
  }

  async updateOk_Hira(res: number, key: string) {
    await this._afDB.database.ref('/users/' + key).update({ ok_hira: res });
  }

  async updateOk_Kata(res: number, key: string) {
    await this._afDB.database.ref('/users/' + key).update({ ok_kata: res });
  }

  async updateTest_Hira(res: number, key: string) {
    await this._afDB.database.ref('/users/' + key).update({ tests_hira: res });
  }

  async updateTest_Kata(res: number, key: string) {
    await this._afDB.database.ref('/users/' + key).update({ tests_kata: res });
  }

  async updateLanguage(res: string, key: string) {
    await this._afDB.database.ref('/users/' + key).update({ language: res });
  }

  /* TEMPORALES */

  async updateTutoRes(key: string) {
    await this._afDB.database.ref('/users/' + key).child('results_tutorial').remove();
  }

  async updateTutoCan(key: string) {
    await this._afDB.database.ref('/users/' + key).child('canvas_tutorial').remove();
  }
}
